const { AQL_LEVELS } = require('./aql');

const codeValues = {
  1: {'AK': { type_desc: 'AK Accessory - Aksesuar',
              codes: ['Broken - Bozuk',
                      'Scratch - Çizik',
                      'Blackened - Kararmiş',
                      'Uneven - Yamuk',
                      'Wrong direction - Yanliş Yönde',
                      'Missing protective layer - Korumasi Düşmüş',
                      'Rotation of screw - Vida Dönmesi',
                      'Broken screw/Burr - Vida Kirilmasi/Çapak',
                      'Glue on accessory - Yapiştirici Bulaşmasi/Taşmasi',
                      'Missing accessory - Eksik Aksesuar'] },
      'BY': { type_desc: 'BY Inking - Boya',
              codes: ['Over inked - Taşma',
                      'Inking untidy - Bulaşma',
                      'Missing ink - Eksik',
                      'Ink peeling - Soyulma',
                      'Faulty inking - Kanalli/Pürüzlü/Boncuk',
                      'Wrong colour of ink - Yanliş Boya Rengi',
                      'Missing milling - Eksik Freze'] },
      'DK': { type_desc: 'DK Stitching - Dikiş',
              codes: ['Uneven stitch - Yamuk',
                      'Needle hole - Iğne Deliği',
                      'Missing stitch - Eksik',
                      'Unravelling - Sökük',
                      'Loose stitch - Gevşek',
                      'Unhidden thread end - Gizlenmemiş Ip Ucu',
                      'Skipped stitch - Dikiş Atlamasi',
                      'Seam upside down - Dikişin Altaüste Vermesi',
                      'Wrong thread colour - Yanliş Ip Rengi'] },
      'DR': { type_desc: 'DR Leather/Suede - Deri/Süet',
              codes: ['Scar - Açik Yara',
                      'Scratch - Çizik',
                      'Surface removal - Cilt Soyulmasi',
                      'Colour mismatch - Renk Eşlemesi',
                      'Grain mismatch - Gren Eşlemesi',
                      'Slack - Boşluk',
                      'Crease marks - Kirişiklik',
                      'Glue mark/Over glue on leather - Yapiştirici Bulaşmasi/Taşmasi',
                      'Stain - Deride Leke',
                      'Mark - Deride Iz'] },
      'MH': { type_desc: 'MH Other - Muhtelif',
              codes: ['Leather cracked due to stitching - Dikişin Deriyi Çatlatmasi',
                      'Silver pen - Gümüş Kalem',
                      'Assembly - Montaj',
                      'Print fault - Baksi',
                      'Missing label - Bez Etiket Eksik',
                      'Missing barcode / care card - Bakimbarkod Kart Eksik',
                      'Weaving error - Dokuma Hatasi'] }},
  2: {'DM': { type_desc: 'DM Dimension - Ölçü',
              codes: ['Wrong dimension - Ölçü hatalı',
                      'Logo/Print dimension fault - Logo/baskı ölçüsü hatalı',
                      'Indistinct logo/print - Logo/baskı net değil'] },
      'FU': { type_desc: 'FU Function Test - Monte Testi',
              codes: ['Snap - Çıtçıt',
                      'Eyelet - Kuşgözü',
                      'Trok - Trok'] },
      'MK': { type_desc: 'MK Mechanism - Mekanizma',
              codes: ['Insecure joint - Birleşim yeri sağlam değil',
                      'Insecure spring/clip/pin/screw - Yay/klips/pim/vida sağlam değil',
                      'Not working properly - Doğru çalışmıyor'] },
      'PK': { type_desc: 'PK Packing - Paketleme',
              codes: ['Properly packed in a box or polybag - Düzgün şekilde kutu/poşet içinde paketlenmemiş',
                      'Missing protector - Koruyucusu yok',
                      'Insecure protector - Koruyucu sağlam değil',
                      'Protector mark - Koruyucu iz yapmış'] },
      'QA': { type_desc: 'QA Quality - Kalite',
              codes: ['Wrong colour - Renk hatalı',
                      'Blackout - Kararma',
                      'Scratch - Çizik',
                      'Burr - Pürüz',
                      'Abrasion - Aşınma',
                      'Coating shedding - Kaplama dökülmesi',
                      'Stain - Leke'] }},
  3: {'DM': { type_desc: 'DM Dimension - Ölçü',
              codes: ['Wrong dimension - Boyut ve ölçü hatalı',
                      'Wrong thickness - Kalınlık hatalı'] },
      'PK': { type_desc: 'PK Packing - Paketleme',
              codes: ['Not rolled up - Ruloya sarılı değil',
                      'Folding/Crease mark - Katlama/kırılma izi'] },
      'QA': { type_desc: 'QA Quality - Kalite',
              codes: ['Wrong colour - Renk hatalı',
                      'Abrage - Abraj var'] }},
  4: {'DM': { type_desc: 'DM Dimension - Ölçü',
              codes: ['Wrong dimension - Ölçü hatalı',
                      'Wrong thickness - Kalınlık hatalı',
                      'Wrong handfeel - Yumuşaklık/Sertlik hatalı'] },
      'PK': { type_desc: 'PK Packing - Paketleme',
              codes: ['Wrapping Mark - Sarma izi var',
                      'Crease mark at palette - Paletteki derilerde kırılma izi oluşmuş',
                      'Different batches put in delivery - Farklı üretim partileri'] },
      'QA': { type_desc: 'QA Quality - Kalite',
              codes: ['Missing customer approval stamp - Müşteri onay damgası yok',
                      'Wrong colour - Renk hatalı',
                      'Lining colour is not matching to leather - Astar boyası deri renginde değil',
                      'Colour difference between sides - Kanatlar arasında renk farkı var',
                      'Grain difference between sides - Kanatlar arasında gren farkı var',
                      'parlak farkı var - Brightness difference between sides - Kanatlar arasında ma',
                      'Plate mark - Plaka izi',
                      'Abrage - Abraj / Efekt',
                      'Scar - Yara',
                      'Loose leather - Boşluk',
                      'Bristle mark - Kıldibi',
                      'Salt mark - Tuzyeniği',
                      'Black mark - Siyah nokta',
                      'Cracked leather - Çatlama'] },
      'TE': { type_desc: 'TE Testing - Testler',
              codes: ['Wrong colour - Renk hatalı',
                      'Tape - Bant',
                      'Sticker - Meto / sticker iz yapıyor',
                      'Glue - Yapıştırıcı',
                      'Chemical - Solvent / ispirto / kolanya',
                      'Dry colour fastness - Kuru beze boya verme',
                      'Wet colour fastness - Islak beze boya verme',
                      'Water repellence - Su geçirmezlik',
                      'Intelining application - Besleme yapıştırma sonrası boşluk',
                      'Cracking after folding - Kıvırma sonrası çatlama',
                      'Colour fastness after folding - Kıvırma sonrası renk açılma',
                      'Cracking after stitching - Dikişte çatlama'] }},
};

const getDefectCodes = (inspectionType) => {
  const codes = codeValues[inspectionType];
  const keys = Object.keys(codes).sort();
  const defectCodes = [];
  for (const k of keys) {
    const tp = codes[k];
    for (let i = 0; i < tp.codes.length; i++) {
      defectCodes.push({
        defect_code: k + '-' + ("0"+(i+1)).slice(-2),
        defect_type: k,
        defect_index: i + 1,
        defect_code_desc_ENG: tp.codes[i],
        defect_type_desc_ENG: k + ": " + tp['type_desc'],
      });
    }
  }
  return defectCodes;
};

module.exports = {
  AQL_LEVELS,
  getDefectCodes,
};
